import  { useEffect } from 'react';
import useDrivePicker from 'react-google-drive-picker'


export default function Picking() {
  const [openPicker, authResponse] = useDrivePicker();  
  // const customViewsArray = [new google.picker.DocsView()]; // custom view
  const handleOpenPicker = () => {
    openPicker({
      clientId: "829850472501-2ac5obm05fpt2odrq68j89h6ibjba5bp.apps.googleusercontent.com",
      developerKey: "AIzaSyAufe8UmHNH83T2jGi0SvuKn0dMHMoNPtc",
      viewId: "FOLDERS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.action === 'cancel') {
          console.log('User clicked cancel/close button')
        }
        console.log(data)
      },
    })
  }


  
  return (
    <div>
        <button onClick={() => handleOpenPicker()}>Open Picker</button>
    </div>
  );
}

